<template>
    <div>
      <div class="container-fluid">
        <div class="row full-height">
            <div class="card mt-4 pt-3 px-3 h-100 full-page-card">
                <h2 class="card-title">Create Drop</h2>
                <div class="row cols full-page-card__content">
                    <div class="col-md-8">
                        <div class="alert alert-success" role="alert" v-if="is_success">
                                Drop created successfully!
                        </div>
                        <div class="alert alert-danger" role="alert" v-if="is_error">
                            {{ this.error_message }}
                        </div>
                        <h4 style="color:chocolate">Charity</h4>
                        <div class="row">
                            <div class="col-md-6">
                                <base-input label="Charity">
                                    <select
                                        v-model="charityId"
                                        class="form-control select--yes-no"
                                        @change="popolateCharityBranches(charityId)"
                                    >
                                        <option value="" disabled selected>Select Charity</option>
                                        <option
                                            v-for="(option, index) in charities"
                                            :value="option.id"
                                            >
                                            {{ option.name }}
                                        </option>
                                    </select>
                                    <div v-if="errorFlags.charityId" id="submit-error" class="has-text-danger" style="color:red; font-size: small;">Please select a charity.</div>
                                </base-input>

                            </div>
                            <div class="col-md-6">
                                <base-input label="Charity's Branch">
                                    <select
                                            v-model="charityBranchId"
                                            class="form-control select--yes-no"
                                            @change="populateCharityVolunteerUsers($event)"
                                        >
                                            <option value="" disabled selected>Select Charity's Branch</option>
                                            <option
                                                v-for="(option, index) in charityBranches"
                                                :value="option.id"
                                                >
                                                {{ option.name }}
                                            </option>
                                    </select>
                                    <div v-if="errorFlags.charityBranchId" id="submit-error" class="has-text-danger" style="color:red; font-size: small;">Please select charity's branch.</div>
                                </base-input>
                            </div>
                        </div>

                        <h4 style="color:chocolate">Retailer</h4>

                        <div class="row">
                            <div class="col-md-6">
                                <base-input label="Retailer">

                                    <select
                                        v-model="retailerId"
                                        class="form-control select--yes-no"
                                        @change="populateRetailerBranches($event)"
                                    >
                                        <option value="" disabled selected>Select Retailer</option>
                                        <option
                                            v-for="(option, index) in retailers"
                                            :value="option.id"
                                            >
                                            {{ option.name }}
                                        </option>
                                    </select>
                                    <div v-if="errorFlags.retailerId" id="submit-error" class="has-text-danger" style="color:red; font-size: small;">Please select a retailer.</div>

                                </base-input>
                            </div>
                            <div class="col-md-6">
                                <base-input label="Retailer's Branch" >
                                    <select
                                            v-model="retailerBranchId"
                                            class="form-control select--yes-no"
                                            @change="onChangeRetailerBranch($event)"
                                        >
                                        <option value="" disabled selected>Select Retailer's Branch</option>
                                        <option
                                            v-for="(option, index) in retailerBranches"
                                            :value="option.id"
                                            >
                                            {{ option.name }}
                                        </option>
                                    </select>
                                    <div v-if="errorFlags.retailerBranchId" id="submit-error" class="has-text-danger" style="color:red; font-size: small;">Please select a retailer's branch.</div>

                                </base-input>
                            </div>
                        </div>

                        <h4 style="color:chocolate">Volunteer (User)</h4>

                        <div class="row">
                            <div class="col-md-6">
                                <base-input label="Volunteer" >

                                    <select
                                            v-model="volunteerUserId"
                                            class="form-control select--yes-no"
                                            v-on:change="onChangeVolunteerUser($event)"
                                        >
                                        <option value="" disabled selected>Select Volunteer (User)</option>
                                        <option
                                            v-for="(option, index) in charityVolunteerUsers"
                                            :value="option.id"
                                            >
                                            {{ `${option.firstName} ${option.lastName} (${option.email})` }}
                                        </option>
                                    </select>
                                    <div v-if="errorFlags.volunteerUserId" id="submit-error" class="has-text-danger" style="color:red; font-size: small;">Please select a volunteer.</div>
                                </base-input>
                            </div>

                            <div class="col-md-6">
                                <base-input type="date" label="Pickup Date" placeholder="Pickup Date" v-model="pickupDate"></base-input>
                                <div v-if="errorFlags.pickupDate" id="submit-error" class="has-text-danger" style="color:red; font-size: small;">Please select pickup date.</div>
                            </div>

                        </div> <br/>

                        <div class="row">
                            <div class="col-md-4">

                            </div>

                            <div class="col-md-4">
                                <div class="col-header" style="justify-content: flex-end;">
                                    <button @click="createDrop" class="btn btn-success">Save</button>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
    import RetailerLeadsService from '@/services/RetailerLeadsService.js';
    import CharityLeadsService from '@/services/CharityLeadsService.js';
    import StatsService from '@/services/StatsService.js';
    import CharitiesService from '../../../services/CharitiesService';
    import DropsService from '../../../services/DropsService';
    import RetailersService from '../../../services/RetailersService';


    export default {
        name: 'CreateDrop',
        data() {
            return {
                charities: [],
                charityBranches: [],
                charityVolunteerUsers: [],
                retailersAvailabilities: [],
                retailers: [],
                retailerBranches: [],
                charityId: "",
                charityBranchId: "",
                retailerId: "",
                retailerBranchId: "",
                volunteerUserId: "",
                pickupDate: "",
                selectedVolunteerUser: "",
                selectedCharityBranchName: "",
                selectedRetailerName: "",
                selectedCharityBranchId: "",
                selectedRetailerId: "",
                selectedVolunteerUserId: "",
                errorFlags: {
                    charityId: false,
                    charityBranchId: false,
                    retailerId: false,
                    retailerBranchId: false,
                    volunteerUserId: false,
                    pickupDate: false,
                },
                submit_error: ``,
                search_button_class: ``,
                is_success: false,
                is_error : false,
                error_message: ``,
            };
        },

        mounted() {
            this.loadCharities();
            this.loadRetailers();
        },

        methods: {
            clearErrors: function() {
                for(var key in this.errorFlags) {
                    if(this.errorFlags.hasOwnProperty(key)) {
                        this.errorFlags[key] = false;
                    }
                }
                this.submit_error = '';
            },

            validateData: function() {
                this.clearErrors();
                
                var isError = false;
                
                if(!this.charityId || this.charityId <= 0) {
                    this.errorFlags.charityId = true;
                    isError = true;
                }

                if(!this.charityBranchId || this.charityBranchId <= 0) {
                    this.errorFlags.charityBranchId = true;
                    isError = true;
                }

                if(!this.retailerId || this.retailerId <= 0) {
                    this.errorFlags.retailerId = true;
                    isError = true;
                }

                if(!this.retailerBranchId || this.retailerBranchId <= 0) {
                    this.errorFlags.retailerBranchId = true;
                    isError = true;
                }

                if(!this.volunteerUserId || this.volunteerUserId <= 0) {
                    this.errorFlags.volunteerUserId = true;
                    isError = true;
                }

                if(!this.pickupDate || this.pickupDate <= 0) {
                    this.errorFlags.pickupDate = true;
                    isError = true;
                }

                return !isError;
            },

            async onChangeVolunteerUser(e) {
                this.selectedVolunteerUserId = e.target.value;
                this.selectedVolunteerUser = e.target.options[e.target.options.selectedIndex].text;
            },

            async onChangeRetailerBranch(e) {
                this.selectedRetailerId = e.target.value;
                this.selectedRetailerName = e.target.options[e.target.options.selectedIndex].text;
                this.getRetailersAvailabilityPeriods();
            },
            
            async loadCharities() {
                let res = await CharityLeadsService.getAll();
                this.charities = res.data;
            },

            async loadRetailers() {
                let res = await RetailerLeadsService.getAll();
                this.retailers = res.data;
            },

            async popolateCharityBranches(charityId) {
                let res = await StatsService.getCharityLeadStats(charityId);
                this.charityBranches = res.data.myBranches;
            },

            async populateRetailerBranches(e) {
                let retailerId = e.target.value;

                let res = await StatsService.getRetailerLeadStats(retailerId);

                this.retailerBranches = res.data.myBranches;
            },

            async populateCharityVolunteerUsers(e) {
                let charityBranchId = e.target.value;

                this.selectedCharityBranchId = charityBranchId;
                
                this.selectedCharityBranchName = e.target.options[e.target.options.selectedIndex].text;

                let res = await CharitiesService.getCharityVolunteers(charityBranchId);
                
                this.charityVolunteerUsers = res.data;
            },

            async getRetailersAvailabilityPeriods(){
                let response = await RetailersService.getAvailabilityPeriods(this.retailerBranchId);
                this.retailersAvailabilities = response.data;
            },

            async createDrop(){
                if(!this.validateData()) {
                    this.submit_error = 'Please correct all errors to proceed.';
                    return;
                }

                let formData = {
                    // ...this.user,
                    pickupDate: this.pickupDate,
                    userId: this.volunteerUserId,
                    charityId: this.charityId,
                    retailerId: this.retailerId,
                    retailerBranchId: this.retailerBranchId,
                    charityBranchId: this.charityBranchId,
                }
                var drop = {
                    "retailerId": formData.retailerBranchId,
                    "charityId": formData.charityBranchId,
                    "userId": formData.userId,
                    "date": this.computePickupDate(),
                    "started": null,
                    "pickupComplete": null,
                    "dropComplete": null,
                    "bagCount": 0,
                    "confirmed": false,
                    "hasIssue": false,
                    "issueNote": "%7B%22notified%22:0,%22UO%22:null,%22feedback%22:null%7D",
                    "issueResolved": false
                }

                try {
                    this.is_error = false;
                   
                    let dropRes = await DropsService.createOne(drop);

                    this.resetFormFields();

                    this.is_success = true;

                    DropsService.updateSlack(`*Drop Created Succesfully* (dropId: ${dropRes.data.id}, source: Web). Summary:\n\n📅 *${this.getDay(new Date(`${drop.date}`).getDay())} at ${drop.date.substring(11,16)}* [${drop.date.split('T')[0]}]\n🍔 *${this.selectedRetailerName}* [${this.selectedRetailerId}]\n🏡 *${this.selectedCharityBranchName}* [${this.selectedCharityBranchId}]\n😎 *${this.selectedVolunteerUser}* [${this.selectedVolunteerUserId}]`)
                } catch (error) {

                    this.is_error = true;
                    
                    this.error_message = 'Unable to create drop.';
                }
            },

            resetFormFields() {
                this.charityId = "";
                this.charityBranchId = "";
                this.pickupDate = "";
                this.pickupDate = "";
                this.retailerId = "";
                this.retailerBranchId = "";
                this.userId = "";
            },

            getDay(day){
                switch (day){
                    case 1: return "Monday";
                    case 2: return "Tuesday";
                    case 3: return "Wednesday";
                    case 4: return "Thursday";
                    case 5: return "Friday";
                    case 6: return "Saturday";
                    case 0: return "Sunday";
                }
            },

            adjustedDay(day){
                if(day !== 0){
                    return day - 1
                } else { 
                    return 6
                }
            },

            computePickupDate(){
                // pick the retailer 
                this.getRetailersAvailabilityPeriods();
                let response = this.retailersAvailabilities;

                let closingTime = response[ this.adjustedDay(new Date(`${this.pickupDate}`).getDay()) ]
                let closingHour = '';
                let closingMinute = '';

                closingTime.endTimeHours.toString().length == 2 ? closingHour = closingTime.endTimeHours : closingHour = `0${closingTime.endTimeHours}`
                closingTime.endTimeMinutes.toString().length == 2 ? closingMinute = closingTime.endTimeMinutes : closingMinute = `0${closingTime.endTimeMinutes}`
                return `${this.pickupDate}T${closingHour}:${closingMinute}:00.000Z`
            }
        },
    };
  </script>
  
  
  <style lang="scss" scoped>
    
  </style>
  
